import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    SendSharedInboxEmailMessage as SendSharedInboxEmailMessageMutation,
    SendSharedInboxEmailMessageVariables as SendSharedInboxEmailMessageMutationVariables,
    MessageSendFromSharedInboxInput,
} from 'nutshell-graphql-types';

import SEND_SHARED_INBOX_EMAIL_MESSAGE from '../mutations/send-shared-inbox-email-message.graphql';

export const useSendSharedInboxEmailMessage = (): {
    sendSharedInboxEmailMessage: (input: MessageSendFromSharedInboxInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [messageSendFromSharedInbox, {loading, error}] = useMutation<
        SendSharedInboxEmailMessageMutation,
        SendSharedInboxEmailMessageMutationVariables
    >(SEND_SHARED_INBOX_EMAIL_MESSAGE);

    return {
        sendSharedInboxEmailMessage: (input: MessageSendFromSharedInboxInput) => {
            return messageSendFromSharedInbox({
                variables: {input},
            });
        },
        isLoading: loading,
        // @ts-expect-error
        error: error && safelyGetGraphQLErrorMessage(error),
    };
};
